import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/hooks/useAuth';

const ProtectedOutlet: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) {
    const back = location.pathname + location.search;
    sessionStorage.setItem('postLoginRedirect', back);
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default ProtectedOutlet;
